import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { projects } from "@/data/projects";

export const CaseHighlightsSection = () => {
  const featured = projects.slice(0, 3);

  return (
    <section className="py-8 bg-background">
      <div className="max-w-3xl mx-auto px-6">
        <div className="flex items-center justify-between mb-4">
          <h2 className="text-xl font-bold text-wtr-gray">Recent Projects</h2>
          <Link to="/our-work" className="text-sm font-semibold text-wtr-blue hover:underline inline-flex items-center gap-1">
            View all <ArrowRight className="w-3.5 h-3.5" />
          </Link>
        </div>
        <div className="space-y-2">
          {featured.map((project) => (
            <Link
              key={project.id}
              to={`/${project.slug}`}
              className="flex items-start gap-4 bg-card rounded-lg p-3 border border-border hover:shadow-soft transition-shadow"
            >
              {project.photos[0] && (
                <img
                  src={project.photos[0].url}
                  alt={project.photos[0].alt}
                  className="w-20 h-14 object-cover rounded-md shrink-0"
                  loading="lazy"
                />
              )}
              <div className="min-w-0">
                <h3 className="text-sm font-semibold text-wtr-gray leading-tight truncate">{project.title}</h3>
                <p className="text-xs text-wtr-gray-light mt-0.5 line-clamp-2">{project.scope_summary}</p>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
};